const it = {
    Italy: 'Italia',
    lisia: 'LISIA',
    loading: 'Caricamento',
    login: 'Entra',
    cancel: 'Annulla',
    back: 'Indietro',
    close: 'Chiudi',
    signup: 'Registrati',
    email: 'E-mail',
    pick_a_password: 'Scegli una password',
    password: 'Password',
    edit: 'Modifica',
    delete:'Elimina',
    remove: 'Rimuovi',
    save: 'Salva',
    submit: 'Conferma',
    yes: 'Si',
    no: 'No',
    ok: 'Ok',
    eur: '€',
    of_date: 'del',
    queries: 'ricerche',
    subscribe: 'Iscriviti',
    back_to_profile: 'Torna al profilo',
    back_to_login: 'Torna al login',
    back_to_site: 'Torna al sito',
    go_to_login: 'Vai al login',
    error: 'Errore',
    something_is_wrong: 'Qualcosa non va',
    all_ok: 'Info',
    update_successful: 'Aggiornamento riuscito',
    add_card: 'Aggiungi',
    day: 'giorno',
    days: 'giorni',
    month: 'mese',
    months: 'mesi',
    then: 'poi',
    year: 'anno',
    daily: 'Giornaliero',
    monthly: 'Mensile',
    annual: 'Annuale',
    forever: 'per sempre',
    once: 'la prima volta',
    optional: 'Opzionale',
    //todo remove
    giornaliero: 'Giornaliero',
    mensile: 'Mensile',
    annuale: 'Annuale',
    plan: 'Abbonamento',
    current: 'Attuale',
    expiration: 'Scadenza',
    over: 'su',
    available_soon: 'Disponibile a breve',
    credit_card_number: 'Numero Carta',
    user_enabled: 'Attivato',
    user_disabled: 'Disattivato',
    user_email_verified: 'Email verificata',
    user_email_not_verified: 'Email non verificata',
    go_to_app: 'Torna al sito',
    generic_fail_message: 'Qualcosa è andato storto!',
    restore_password: 'Recupera password',
    search_ask_me_something: 'Chiedi a Lisia',
    sidebar_home: 'Home',
    sidebar_profile: 'Profilo',
    sidebar_history: 'Cronologia',
    sidebar_directories: 'Cartelle',
    sidebar_subscription: 'Abbonamento',
    sidebar_admin_panel: 'Pannello di Amministrazione',
    sidebar_logout: 'Esci',
    sidebar_menu: 'Menu',
    history_title: 'Cronologia ricerche',
    history_search_placeholder: 'Cerca tra la cronologia',
    history_order: 'Ordine di tempo',
    history_order_asc: 'crescente',  
    history_order_desc: 'decrescente',
    history_search_again: 'Ricerca nuovamente',
    history_date: 'Data',  
    history_all_time: 'Tutte',
    history_last_7_days: 'Ultimi 7 giorni',
    history_last_month: 'Ultimo mese',
    history_query: 'Ricerca',
    history_query_type: 'Tipo Documento',
    type_principle: 'Massima',
    type_verdict: 'Sentenza integrale',
    folder: 'Cartella',
    folder_name: 'Nome caso/cliente',
    folder_created: 'è stata creata correttamente',
    folder_description: 'La descrizione della cartella',
    folder_description_modified: 'è stata modificata con successo',
    folder_deleted: 'rimossa con successo',
    folders_title: 'La lista delle tue cartelle',
    folders_create_new_folder: 'Crea nuova cartella',
    folders_creation_date: 'Data creazione',
    folders_last_edit_date: 'Ultima modifica',
    folders_delete_title: 'Cancellazione cartella',
    folders_delete_message_prefix: 'Vuoi eliminare la cartella',
    folders_delete_message_suffix: 'e il suo contenuto?',
    folder_element_deleted: 'L\'elemento è stato eliminato correttamente dalla cartella',
    folder_name_exists: 'Esiste già una cartella con lo stesso nome',
    folders_description: 'Descrizione...',
    folders_search: 'Cerca tra le cartelle',
    user_delete_header: 'Cancellazione utente',
    user_delete_message: 'Sei sicuro di voler cancellare l\'utente?',
    subscription_title: 'Il tuo abbonamento',
    subscription_admin_alert: 'Sei Entrato come Amministratore',
    subscription_trial_alert: 'Hai un periodo di prova',
    july_2020_subscription_annual_plan: 'Abbonamento Premium Annuale (30 giorni gratis)',
    july_2020_subscription_monthly_plan: 'Abbonamento Premium Mensile (30 giorni gratis)',
    july_2020_subscription_trial_plan: 'Prova Gratuita ${days} giorni',
    subscription_monthly_plan: 'Abbonamento mensile',
    subscription_annual_plan: 'Abbonamento annuale',
    subscription_daily_plan: 'Abbonamento giornaliero',
    subscription_trial_plan: 'Prova Lisia per ${days} giorni',
    subscription_payment_method_title: 'Metodo di pagamento',
    subscription_payment_method_description_prefix: 'Hai usato la carta',
    subscription_payment_method_description_suffix: 'che termina con',
    subscription_update_payment_method: 'Aggiorna',
    subscription_payment_method_missing: 'Nessun metodo di pagamento',
    subscription_update_payment_method_description: 'L\'aggiornamento dei dati o del metodo di pagamento non attiva o estende il tuo abbonamento nè ne esegue l\'upgrade.',
    subscription_update_payment_method_description_prefix: 'Continuerai a pagare',
    subscription_update_payment_method_description_suffix: 'ogni',
    subscription_payment_intro_returning: 'Inserisci un metodo di pagamento valido',
    subscription_payment_intro: 'Inserisci un metodo di pagamento e ',
    subscription_payment_intro_continued: 'inizia a usare tutte le funzionalità di Lisia gratuitamente',
    subscription_payment_intro_2: 'Non pagherai nulla per i primi 14 giorni',
    subscription_payment_intro_3: 'Disdici quando vuoi ',
    subscription_payment_intro_3_continued: 'nella sezione abbonamento del tuo profilo',
    subscription_payment_method: 'Carta di credito o di debito',
    subscription_payment_pci_compliance: 'Adottiamo la sicurezza degli standard di protezione dei dati di pagamento in conformità delle norme PCI',
    subscription_payment_cancellation: 'Potrai facilmente disdire in qualsiasi momento alla sezione abbonamento del tuo profilo',
    subscription_plan_title_prefix: 'Abbonamento',
    subscription_plan_title_suffix: '',
    subscription_plan_udated: 'Abbonamento aggiornato',
    subscription_plan_udate_fail: 'Non siamo riusciti ad aggiornare il tuo abbonamento',
    subscription_activation_message_prefix: 'Hai un periodo di prova che terminerà il',
    subscription_activation_message_suffix: 'dopodichè il tuo abbonamento a pagamento sarà attivato',
    subscription_renew_message_prefix: 'Il tuo piano sarà rinnovato automaticamente il',
    subscription_will_renew_on: 'Si rinnoverà il',
    subscription_will_expire_on:'Scadrà il',
    subscription_renew_message_suffix: 'e ti sarà addebitato un costo di',
    subscription_query_count_message_prefix: 'Hai effettuato',
    subscription_query_count_message_suffix: 'ricerche su ',
    subscription_queries_left_description_prefix: 'Puoi ancora effettuare',
    subscription_queries_left_description_suffix: 'ricerche questo mese, dopodiché ogni ricerca costerà 0.05€.',
    subscription_queries_over_prefix: 'Hai terminato le',
    subscription_queries_over_suffix: 'ricerche previste per questo mese. Hai effettuato ',
    subscription_additional_queries_description :'ulteriori ricerche al costo aggiuntivo di 0.05€ ciascuna.',
    subscription_expired: 'Il tuo abbonamento non è attivo',
    subscription_no_queries: 'Hai consumato tutte le tue ricerche',
    subscription_add: 'Aggiungi un abbonamento',
    subscription_manage: 'Gestisci abbonamento',
    subscription_manage_body: 'Gestisci il tuo abbonamento nella sezione relativa oppure cliccando su "Gestisci abbonamento"',
    subscription_manage_alert_body: 'Non potrai effettuare ricerche finchè non risolverai i problemi del tuo abbonamento. Vai nella sezione "Gestisci abbonamento" per maggiori informazioni',
    subscription_cancellation_success_header: 'Cancellazione riuscita',
    subscription_cancellation_success_message: 'Il tuo abbonamento è stato cancellato con successo',
    subscription_cancellation_fail_message: 'Non siamo riusciti a cancellare il tuo abbonamento',
    subscription_edit_or_cancel: 'Gestisci l\'abbonamento',
    subscription_change: 'Cambia',
    subscription_change_plan: 'Aggiorna il tuo abbonamento',
    subscription_change_plan_description: 'Cliccando su "Iscriviti" ti sarà richiesta una conferma. Accettando ti sarà automaticamente assegnato il nuovo piano e ti sarà addebitato l\'importo del nuovo piano. Il rinnovo partirà dalla data di cambio del piano.',
    subscription_enterprise_plan_title: 'Enterprise',
    subscription_enterprise_plan_subtitle: 'Il piano creato in base alle tue esigenze',
    subscription_enterprise_plan_description: 'Un piano progettato esclusivamente per te, in base alle tue richieste e alle tue esigenze. Sapremmo sicuramente accontentarti al meglio.',
    subscription_enterprise_contact_us: 'Per info scrivici in chat',
    subscription_periodic_plan_active_description_prefix: 'Questo piano ti permette di effettuare ',
    subscription_periodic_plan_description_prefix: 'Questo piano ti permetterebbe di effettuare',
    subscription_periodic_plan_description_suffix: ' ricerche ogni ',
    subscription_periodic_plan_active: 'Sei iscritto a questo piano',
    subscription_delete_your_account: 'Cancella il tuo account',
    subscription_payment_method_updated: 'Metodo di pagamento aggiornato',
    subscription_payment_method_update_fail: 'Non siamo riusciti ad aggiornare il tuo metodo di pagamento',
    subscription_payment_list_title: 'Storico pagamenti',
    subscription_paid_amount: 'Importo pagato',
    subscription_amount_due: 'Importo dovuto',
    subscription_payment_date: 'Data pagamento',
    subscription_download_invoice: 'Scarica',
    subscription_pay_invoice: 'Paga',
    subscription_trial_disclamer: 'Avrai a disposizione un periodo di prova di ${days} giorni, dopodichè ti verrà addebitato il primo ${interval} dell\'abbonamento',
    subscription_trial_disclamer_capital: 'PROVA GRATUITA ${days} GIORNI',
    subscription_trial_admin_disclamer: 'Include un periodo di prova di ${days} giorni',
    subscription_trial_offer: 'Un\'offerta limitata:',
    subscription_expires_after: 'scade dopo',
    subscription_expires_on: 'L\'abbonamento scadrà il',
    subscription_one_time_offer: 'Ti avviseremo prima del termine del periodo di prova',
    subscription_renews_on_expiration: 'L\'abbonamento si rinnoverà automaticamente ogni ${interval}',
    subscription_free_deactivation: 'Potrai facilmente disdire prima della scadenza della prova, ',
    subscription_renews_on_trial_expiration: 'altrimenti l\'abbonamento si rinnoverà automaticamente ogni ${interval}',
    subscription_wont_renew_on_expiration: 'L\'abbonamento non verrà rinnovato',
    subscription_no_plan: 'Non hai sottoscritto nessun abbonamento',
    subscription_update_plan_confirm : 'conferma la tua decisione',
    subscription_license_will_expire_on : 'La tua licenza scadrà il',
    subscription_coupon_period_prefix: 'per i primi ',
    subscription_coupon_redeem_by: 'Valida fino al',
    subscription_coupon_valid_until: 'fino al',
    subscription_will_be_paid_on: 'Il costo dell\'abbonamento verrà addebitato sul seguente metodo di pagamento:',
    subscription_plan_change_description: 'Confermi di voler aggiornare il tuo abbonamento?',
    subscription_cancel_renewal: 'Disdici l\'abbonamento',
    subscription_restore_renewal: 'Rinnova l\'abbonamento',
    subscription_cancel_renewal_confirm: ' vuoi veramente disdire l\'abbonamento?',
    subscription_cancel_renewal_confirm_details: 'Con la disdetta dell\'abbonamento non potrai più effettuare ricerche al raggiungimento della data di scadenza. Il tuo profilo resterà attivo e potrai tornare qui e rinnovare l\'abbonamento in qualunque momento!',
    subscription_active: 'Attivo',
    subscription_not_active: 'Non Attivo',
    subscription_default_plan_title: 'Solo dopo ${days} giorni di prova gratuita inizierai a pagare ${discount_price}${currency} al mese anziché ',
    subscription_default_description_item_1: 'Numero di ricerche illimitato',
    subscription_default_description_item_2: 'Accesso contemporaneo da desktop e mobile',
    subscription_default_description_item_3: 'Sentenze e massime aggiornate settimanalmente',
    subscription_default_description_item_4: 'Gestione ed organizzazione delle ricerche in cartelle',
    subscription_default_description_item_5: 'Assistenza clienti garantita 12 ore al giorno',
    invoice_heading_prefix: '',
    invoice_heading_suffix: '',
    invoice_scheduled: 'Programmata',
    invoice_paid: 'Pagata',
    invoice_payment_failed: 'Pagamento non riuscito',
    invoice_payment_succeeded: 'Pagamento riuscito',
    invoice_due: 'Non Pagata',
    invoice_voided: 'Cancellata',
    do_you_hate_us : ' vuoi cancellare il tuo account?',
    you_still_have_time: 'Hai ancora del tempo prima che',
    your_trial: 'la tua prova',
    your_subscription: 'il tuo abbonamento',
    expires: 'scada',
    tell_us_your_problems: 'Contattaci in chat per parlare dei tuoi problemi oppure trovare un punto di incontro per aiutarti ad usare al meglio Lisia per la crescita del tuo studio.',
    help_us: '',
    user_profile_your_profile: 'Il tuo profilo',
    user_profile_user_profile: 'Profilo utente',
    user_profile_first_name: 'Inserisci il tuo nome',
    user_profile_last_name: 'Inserisci il tuo cognome',
    user_profile_email: 'Inserisci la tua email',
    user_profile_queries: 'Richieste',
    user_profile_paid_account: 'Abbonamento a Pagamento',
    user_profile_license_expiration: 'Valido Fino',
    user_profile_registration_date: 'Data Registrazione',
    user_profile_actions: 'Azioni',
    user_profile_refresh_queries: 'Aggiorna ricerche',
    user_profile_add_queries: 'Aggiungi ricerche',
    user_profile_reset_queries: 'Ressetta ricerche',
    user_profile_edit_profile: 'Modifica utente',
    user_profile_delete_user: 'Elimina utente',
    user_profile_show_payment_methods: 'Mostra Metodi di pagamento',
    user_profile_payment_methods: 'Metodi di pagamento',
    user_profile_show_billing_info: 'Mostra informazioni di fatturazione',
    user_profile_billing_info: 'Informazioni di fatturazione',
    user_profile_created: 'Profilo utente creato',
    user_profile_updated: 'Profilo utente aggiornato',
    user_profile_update_failed: 'Non siamo riusciti ad aggiornare il tuo Profilo utente, controlla i dati e riprova',
    user_profile_deleted: 'Profilo utente cancellato',
    user_profile_load_error: 'Errore durante il caricamento del profilo utente',
    user_profile_we_need_some_info: 'Abbiamo bisogno di alcune informazioni',
    user_profile_invoice_settings_info: 'Per poter evadere le tue fatture in modo corretto abbiamo bisogno di alcune informazioni aggiuntive, puoi aggiungere le informazioni necessarie nella sezione \'Informazioni di Fatturazione\' del tuo profilo.',
    with_subscription: 'Con abbonamento',
    add_user: 'Aggiungi utente',
    signup_account_information: 'Informazioni account',
    signup_i_am_a_lawyer: 'Sono un avvocato',
    signup_i_declare_that: 'Professione',
    signup_i_accept_terms: 'Ho letto ed accetto le',
    signup_i_accept_terms_anchor: 'condizioni d\'uso',
    signup_plan_type: 'Tipo di abbonamento',
    signup_trial_disclamer: 'Avrai a disposizione un periodo di prova',
    signup_name_is_required: 'Il nome è un\'informazione richiesta.',
    signup_surname_is_required: 'Il cognome è un\'informazione richiesta.',
    signup_email_is_required: 'L\'email è un\'informazione richiesta.',
    signup_email_is_invalid: 'L\'email inserita non è valida.',
    signup_plan_is_required: 'Per favore scegli un abbonamento.',
    signup_password_is_required: 'La password è un\'informazione richiesta.',
    signup_lawyer_type_is_required: 'Seleziona un\'opzione',
    signup_terms_required: 'Devi accettare i termini e le condizioni',
    signup_payment_method_is_required: 'Inserisci un metodo di pagamento',
    signup_queries_must_be_positive: 'Il numero di ricerche deve errere maggiore o uguale a 0',
    signup_card_requires_plan: 'Gli utenti con un metodo di pagamento devono avere un abbonamento',
    signup_success: 'Registrazione completata!',
    signup_failed: 'Registrazione fallita, riprova più tardi',
    signup_payment_authentication_failed: 'La creazione dell\'abbonamento non è andata a buon fine a causa di un problema con il metodo di pagamento',
    signup_success_payment_authentication_failed: 'La creazione dell\'abbonamento è andata a buon fine ma il pagamento è fallito a causa di un problema con il metodo di pagamento, potrai risolvere il problema andando nella sezione abbonamento del tuo profilo',
    signup_success_no_pwd: 'Registrazione completata! Controlla la tua email per eseguire l\'accesso',
    signup_success_panel_title: 'Ti abbiamo inviato una email di verifica!',
    signup_success_panel_body: 'Per completare la tua iscrizione controlla la tua casella di posta in arrivo (${email}) e clicca sul link contenuto nella mail',
    signup_success_alert_body: 'Se non trovi la nostra email nella posta in arrivo controlla la posta indesiderata.',
    signup_warning_message: 'Ti avviseremo prima dello scadere del termine della prova gratuita, e in quel momento potrai decidere liberamente se proseguire con l\'abbonamento o interrompere il servizio.',
    signup_select_an_option: 'Professione: seleziona un\'opzione',
    signup_card_auth_descriptor: 'LISIA - Abbonamento',
    signup_integration_panel_title: 'sottoscrivi un abbonamento',
    signup_integration_panel_title_2: ' ti manca l’ultimo passaggio per accedere!',
    signup_integration_panel_subtitle: 'Inizia subito la prova gratuita di ${days} giorni.',
    signup_integration_panel_subtitle_2: ' potrai facilmente disdire prima della scadenza della prova alla sezione abbonamento del tuo profilo',    
    signup_integration_panel_subtitle_3: 'Hai selezionato il piano da ${price}${currency} / ${interval}',
    signup_integration_panel_subtitle_4: ' potrai facilmente disdire il rinnovo automatico alla sezione abbonamento del tuo profilo',
    signup_integration_panel_subtitle_5: 'Avrai a disposizione:',
    signup_your_plan_will_be: 'Il tuo abbonamento sarà: ',
    signup_change_plan_description: 'Seleziona il piano che preferisci',
    signup_change_plan_description_free: 'non pagherai nulla per i primi ${days} giorni.',
    send_verification_email_panel_title: 'Ti abbiamo inviato una email di verifica!',
    send_verification_email_panel_body: 'Ti abbiamo inviato una mail all\'indirizzo ${email}, per verificarlo, controlla la tua casella di posta in arrivo e clicca sul link contenuto nella mail',
    send_verification_email_alert_body: 'Se non trovi la nostra email nella posta in arrivo controlla la posta indesiderata.',
    new_verification_email_sent: 'Ti abbiamo inviato una nuova email di verifica',
    verification_email_failed: 'Non siamo riusciti ad inviarti una nuova emaiil di verifica.',
    plans_load_failed: 'Non siamo riusciti a caricare le informazioni degli abbonamenti, riprova più tardi',
    restore_password_description: 'Inserisci la mail dell\'account di cui vuoi recuperare la password',
    restore_password_instructions: 'Le Istruzioni per ripristinare la password verranno inviate alla mail indicata',
    restore_password_send: 'Ripristina password',
    change_password_description: 'Immettere la nuova password',
    change_password_button: 'Cambia password',
    update_password: 'Aggiorna password',
    insert_old_password: 'Vecchia password',
    insert_new_password: 'Nuova password',
    confirm_new_password: 'Conferma la nuova password',
    repeat_new_password: 'Ripeti nuova password',
    passwords_dont_match: 'Le password non combaciano',
    old_password_is_required: 'La vecchia password è necessaria',
    new_password_is_required: 'La nuova password è necessaria',
    repeat_password_is_required: 'Devi ripetere la nuova password due volte',
    admin_usesr_profile_verified_email: 'Stato email',
    admin_users_all: 'Tutti',
    admin_users_disabled: 'Disabilitati',
    admin_users_enabled: 'Abilitati',
    admin_users_email_verified: 'Con email verificata',
    admin_users_email_not_verified: 'Senza email verificata',
    admin_users_search: 'Cerca...',
    admin_user_queries: 'Ricerche',
    admin_user_enabled: 'Abilitato',
    admin_user_disabled: 'Disabilitato',
    admin_user_profile_email: 'Email',
    admin_user_profile_first_name: 'Nome',
    admin_user_profile_last_name: 'Cognome',
    server_error_login: 'La richiesta richiede un token di accesso, per favore accedi',
    server_error_wrong_data: 'L\'utente o la password sono sbagliati',
    server_error_user_not_exists: 'L\'utente non esiste',
    server_error_account_disabled: 'Il tuo account è stato disabilitato',
    server_error_missing_data: 'Mancano alcuni parametri richiesti',
    server_error_wrong_email_format: 'L\'email non è in un formato valido',
    server_error_wrong_password_format: 'La password deve essere di almeno 6 caratteri',
    server_error_used_email: 'L\'email è già utilizzata',
    server_error_token_updated: 'Token aggiornato correttamente',
    server_error_token_valid: 'Token ancora valido',
    server_error_token_not_valid: 'Token non valido',
    server_error_token_expired: 'Sessione scaduta effettua nuovamente il login',
    server_error_email_not_found: 'Email non trovata',
    server_message_password_email_sent: 'Ti abbiamo inviato un\'e-mail con la tua nuova password',
    server_message_recovery_email_sent: 'Ti abbiamo inviato un\'e-mail contenente le istruzioni per ripristinare la tua password',
    server_error_invalid_code: 'Codice non valido',
    server_error_file_not_found: 'File non trovato',
    server_error_userame_is_empty: 'Il nome utente non può essere vuoto',
    server_error_error_updating: 'Errore durante l\'aggiornamento',
    server_error_user_not_found: 'Non abbiamo trovato nessun utente con l\'id richiesto',
    server_error_wrong_old_password:  'Vecchia password non corrispondente',
    server_error_missing_params:  'Mancano alcuni parametri richiesti',
    server_error_account_expired: 'Ci dispiace ma il tuo account è scaduto',
    server_error_another_session_open: 'Hai effettuato il login da un altro dispositivo, questa sessione è stata chiusa.',
    server_error_password_changed_already: 'Il collegamento usato per ripristinare la password non è più valido, si prega di generare una nuova richiesta di ripristino password',
    server_message_password_successfully_changed: 'Password aggiornata correttamente',
    server_error_internal_server_error: 'Errore Sconosciuto',
    server_error_email_exist: 'Email già in uso',
    server_message_password_updated: 'Password aggiornata',
    search_area_court: 'Corte di Cassazione',
    search_area_tribunals: 'Tribunali e Corti d\'Appello',
    search_type_verdict: 'Sentenza',
    search_type_rule: 'Massima',
    search_filter_all: 'Tutte',
    search_filter_law: 'Giurisprudenza',
    search_filter_regulations: 'Normativa',
    search_filter_codes: 'Codici Commentati',
    search_filter_doctrine: 'Dottrina',
    search_filter_in_depth: 'Approfondimenti',
    search_rule_heading: 'MASSIMA',
    search_synthetic_rule_heading: 'ESTRATTO',
    search_access_denied: 'Accesso negato',
    search_access_from_two_devices: 'Sei entrato da due dispositivi',
    search_login_again_to_search: 'È necessario accedere nuovamente per utilizzare il sistema',
    search_no_results: 'Ci dispiace ma non troviamo alcun documento significativo.',
    search_search_rules: 'Massime',
    search_search_verdicts: 'Sentenze Integrali',
    search_reset_filters: 'Fai click sul pulsante seguente per rimuovere i filtri che hai appena applicato',
    search_reset_filters_button: 'Reset filtri',
    search_filters_title: 'Filtra risultati',
    search_authority: 'Autorità giudiziaria',
    search_filters_authority: 'Filtra per autorità giudiziaria',
    search_year: 'Anno',
    search_filters_year: 'Filtra per anno',
    search_filter_button: 'Aggiorna',
    search_load_more: 'Carica altri risultati',
    search_folder_exists: 'Esiste già una cartella con lo stesso nome',
    search_response_heading: 'RISPOSTA',
    search_search_rules_popup: 'Massime autorali e massime generate da Lisia',
    search_search_synthetic_popup: 'Lisia estrae la parte di testo rilevante direttamente dalle sentenze integrali. Clicca sul testo per andare alla parte evidenziata',
    result_components: 'Componenti',
    result_feedback_positive: 'Positivo',
    result_verdict_number: 'n.',
    result_verdict: 'sentenza',
    result_full_document: 'Documento completo',
    result_full_verdict: 'Sentenza integrale',
    result_full_verdict_capital: 'SENTENZA INTEGRALE',
    result_saved_heading: 'Risultato memorizzato',
    result_saved_description: 'Il risultato è stato memorizzato nella cartella',
    result_folder_description_heading: 'Aggungi una descrizione per la cartella',
    result_folder_description: 'Inserisci qui la descrizione della tua nuova cartella...',
    result_add_to_existing: 'Aggiungi ad una cartella esistente o digita il nome di una nuova',
    result_folder_name_limit_exceeded: 'Il nome della cartella non può superare i 50 caratteri! Continuando, il nome verrà troncato.',
    result_folder_select: 'Scegli una cartella',
    result_folder_create: 'Crea cartella',
    result_folder_remove_item: 'Clicca su questa icona se desideri rimuovere l\'elemento dalla cartella',
    result_negative_feedback_description: 'Facci sapere perché questa risposta non è pertinente...',
    result_positive_feedback_description: 'Vota questo risultato se lo reputi pertinente alla tua richiesta. Ci aiuterai a migliorare la nostra intelligenza artificiale',
    result_feedback_saved: 'Feedback ricevuto',
    result_feedback_thanks: 'Grazie per il feedback!',
    result_of_city: ' di ',
    result_tribunal_of: 'Tribunale di',
    result_court_of_appeal_of: 'Corte d\'appello di',
    result_supreme_court: 'Corte Suprema di Cassazione',
    result_issuer_judge: 'Giudice di pace',
    result_freedom_tribunal: 'Tribunale delle libertà',
    result_minors_tribunal: 'Tribunale per i minorenni',
    result_tar: 'Tribunale Amministrativo Regionale',
    result_state_council: 'Consiglio di stato',
    result_ctp: 'Commissione tributaria provinciale',
    result_ctr: 'Commissione tributaria regionale',
    result_cga: 'Consiglio di giustizia amministrativa',
    result_section: 'sez.',
    result_section_capital: 'Sezione',
    result_first: 'prima',
    result_second: 'seconda',
    result_third: 'terza',
    result_fourth: 'quarta',
    result_fifth: 'quinta',
    result_sixth: 'sesta',
    result_seventh: 'settima',
    result_eighth: 'ottava',
    result_ninth: 'nona',
    result_civil: 'civile',
    result_penal: 'penale',
    result_administrative: 'amministrativa',
    result_tributary: 'tributaria',
    result_work: 'lavoro',
    result_minors: 'minori',
    result_family: 'famiglia',
    result_close_and_go_up: 'Chiudi e torna su',
    result_click_to_highlight_in_text: 'Clicca sul testo per andare direttamente alla parte evidenziata',
    result_is_synthetic: 'Lisia estrae la parte di testo rilevante della sentenza',
    result_is_pure_heading: 'Massima',
    result_is_synthetic_heading: 'Testo estratto dalla ',
    result_is_synthetic_heading_2: 'sentenza',
    email_in_use: 'Email già usata',
    email_was_in_use: 'La tua email è già nei nostri sistemi, non puoi accedere all\'offerta selezionata',
    verify_email_title: 'Verifica email',
    verify_email_description: 'Prima di poter accedere devi verificare l\'indirizzo email indicato durante la fase di registrazione e visualizzato qui sotto, una volta completata la registrazione dovresti aver ricevuto un\'email, clicca sul link contenuto nella mail per verificarla.',
    no_email_received: 'Non ho ricevuto nessuna email',
    user_was_registered: 'Ci risulta che tu eri già registrato, bentornato!',
    verification_email_sent: 'Ti abbiamo inviato una nuova email di verifica, se non la vedi controlla la cartella dello spam',
    email_verified: 'Email Verificata! Ti stiamo reindirizzando verso Lisia...',
    lawyer_check_text: 'Dichiarazione di conformità',
    therms_and_conditions_title: 'Termini e condizioni',
    therms_and_conditions: 'Termini e condizioni d\'uso',
    add_billing_info: 'Aggiungi informazioni di fatturazione',
    billing_info_invoice_type: 'Tipo di fattura',
    billing_info_invoice_type_receipt: 'Ricevuta (se non hai partita IVA)',
    billing_info_invoice_type_invoice: 'Fattura (se hai partita IVA)',
    billing_info_title: 'Informazioni di fatturazione',
    billing_info_address: 'Indirizzo',
    billing_info_address_placeholder: 'Indirizzo e numero civico',
    billing_info_address_complement: 'Scala, piano, interno ecc. (Opzionale)',
    billing_info_zip_code: 'Codice postale',
    billing_info_city: 'Città',
    billing_info_state: 'Provincia',
    billing_info_country: 'Nazione',
    billing_info_vat_number: 'Partita Iva',
    billing_info_fiscal_code: 'Codice Fiscale',
    billing_info_fe_code: 'Codice Destinatario',
    billing_info_pec: 'Indirizzo Posta Elettronica Certificata',
    billing_info_fe_code_or_pec: 'Codice Destinatario o Indirizzo Posta Elettronica Certificata',
    billing_info_pec_or_code_required: 'Devi indicare un Codice Destinatario o un indirizzo di posta elettronica certificata',
    billing_info_address_required: 'L\'indirizzo è un\'informazione richiesta',
    billing_info_vat_number_required: 'La partita IVA è un\'informazione richiesta',
    billing_info_fiscal_code_required: 'Il codice fiscale è un\'informazione richiesta',
    billing_info_vat_or_fc_required: 'Devi indicare una partita IVA o un Codice Fiscale',
    billing_info_check: 'Controlla le informazioni di fatturazione',
    tax_id_invalid: 'Il formato della partita iva non è valido',
    billing_info_fiscal_code_format_invalid: 'Il codice fiscale non è valido',
    resource_missing: 'Nessun metodo di pagamento trovato, per sottoscrivere un abbonamento aggiungi un metodo di pagamento'
  };
  
  export default it;